<template>
	<picture v-if="images.length">
		<source :srcset="getImage('large')" media="(min-width: 1024px)" />
		<source :srcset="getImage('medium')" media="(min-width: 720px)" />
		<source :srcset="getImage('small')" media="not all and (min-width: 720px)" />
		<img :src="getImage('small') || getImage('medium') || getImage('large')" />
	</picture>
</template>

<script>
export default {
	props: {
		images: { type: Array, required: true },
	},
	methods: {
		getImage(type) {
			return (this.images.find((image) => type.toUpperCase() === image.resolutionType) || { url: false }).url;
		},
	},
};
</script>

<style scoped>
img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
</style>
